export enum BenefitChoosen {
  MoreThanOne = 0,
  SurvivalPension = 1,
  ReimbursementFuneral = 2,
  FuneralAllowance = 3,
}
